export default __webpack_public_path__ + "static/media/Can Şengün.da85ee26.jpg";